import { render, staticRenderFns } from "./ContentDetailView.vue?vue&type=template&id=fd6f71a4&scoped=true"
import script from "./ContentDetailView.vue?vue&type=script&lang=js"
export * from "./ContentDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6f71a4",
  null
  
)

export default component.exports